import Cookies from 'js-cookie';
import { isInRole, readAccessToken } from '../jwt/JwtReader';
import { ACCESS_TOKEN_COOKIE_NAME, PRO_USER_CORE_ROLE } from '../constants/Constants';

const User = {
  isProUser() {
    const authCookie = Cookies.get(ACCESS_TOKEN_COOKIE_NAME) || '';
    const userAccessToken = readAccessToken(authCookie);
    const hasIICore = isInRole(authCookie, PRO_USER_CORE_ROLE);
    return hasIICore && userAccessToken.authenticated;
  },
};

export default User;
